var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCnnoDTzh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "#EE3D85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9175 30.237C46.9175 31.3643 45.9311 32.3507 44.8038 32.3507L38.0397 32.3507C36.9828 32.4212 36.1373 31.5757 36.2078 30.5188L36.1373 26.9254C33.1076 26.0095 30.9234 25.6572 28.3164 25.7276C25.9208 25.7276 23.8071 26.2913 21.2706 26.9959V30.5188C21.2706 31.6461 20.4955 32.4212 19.3682 32.4212H12.6042C11.4768 32.4212 10.5609 31.5052 10.4904 30.3074C10.4904 29.321 10.5609 28.2641 10.4904 27.2073C10.3495 15.793 47.0584 15.7225 46.9175 27.1368C46.9175 28.2641 46.9175 29.2506 46.9175 30.237Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCnnoDTzh);
export default __webpack_public_path__ + "static/media/cnnoDTzh.0c7315e0654463c2c165683d572b130f.svg";
export { ForwardRef as ReactComponent };